import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import AlertComp from "./components/alert/Alert";
import Loading from "./components/loadingComp/Loading";
import { router } from "./routes";
import { getUser, isLogin } from "./Store/Actions/AuthAction";
import Storage from "./utills/AsyncStorage";

function App() {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.AuthReducer?.isLogin);

  useEffect(() => {
    const userData = Storage.getUser("@user");
    const token = Storage.getToken();
    if (userData && token) {
      dispatch(getUser(userData));
      dispatch(isLogin(true));
    } else {
      dispatch(getUser(null));
      dispatch(isLogin(false));
    }
  }, []);

  return islogin == null ? (
    <></>
  ) : (
    <>
      <AlertComp />
      <Loading />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
